module.exports = __webpack_public_path__ + "static/007229-4f769b8629345089d7cf6d59995541cc.jpg";